const loadVendor = ( name, callback ) => {
	if ( themeVars && themeVars?.vendors[name] ) {
		if ( !themeVars.vendors[name].promise ) {			
			Object.values( themeVars.vendors[name]?.urls ).map( ( url ) => {
				if ( url.match( /.js$/ ) ) {
					themeVars.vendors[name].promise = new Promise( ( resolve ) => {
						$.ajax( {
							url: url,
							dataType: 'script',
							success: () => {
								resolve();
							},
							cache: true
						} );
					} );
				}
			} );
		} 

		themeVars.vendors[name].promise.then( callback );
	}
};

export default loadVendor;